import { reactive } from 'vue';
import { IState } from '@/models/store/state.interface';

const state: any = reactive({
	campaignId: 0,
	standAloneLogin: false
});

export default state as IState;
